import { render, staticRenderFns } from "./RequestIncidentSidebar.vue?vue&type=template&id=3b9bb752&scoped=true&"
import script from "./RequestIncidentSidebar.vue?vue&type=script&lang=js&"
export * from "./RequestIncidentSidebar.vue?vue&type=script&lang=js&"
import style0 from "./RequestIncidentSidebar.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RequestIncidentSidebar.vue?vue&type=style&index=1&id=3b9bb752&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9bb752",
  null
  
)

export default component.exports